<nav class="unav">
  <a class="nav-logo" href="pc_home.html">
    <img src="assets/img/logo.png" alt="Police Officers Connect Logo">
    <div><div class="nav-brand-name">Police Officers Connect</div><div class="nav-brand-sub">UMYO Network</div></div>
  </a>
  <button class="unav-tog" id="navTog" (click)="toggleNav()"><span></span><span></span><span></span></button>
  <ul class="unav-links" id="navLinks" [class.nav-open]="isNavOpen">
    <li><a routerLink="/" >Home</a></li>
    <li><a routerLink="/about" >About</a></li>
    <li><a routerLink="/support">Officer Support</a></li>
    <li><a routerLink="/business">For Business</a></li>
    <li><a routerLink="/services">Type Of Services</a></li>
    <li><a routerLink="/cf">Card Features</a></li>
  </ul>
  <a href="#header" class="nav-cta">Join Now</a>
</nav>
<!-- HERO -->
<div class="page-hero" style="background:linear-gradient(160deg,var(--black) 0%,#0a0f1e 30%,#0d1f35 60%,var(--black) 100%);">
  <div class="hero-grid"></div>
  <div style="position:relative;z-index:1;width:100%;max-width:800px;margin:0 auto;">
    <span class="hero-badge">&#9878; Legal &amp; Platform Policies</span>
    <h1 class="hero-title">Terms <em>&amp;</em><br>Conditions</h1>
    <span class="gold-bar"></span>
    <p class="hero-sub">Please read these terms carefully before participating in any UMYO Police Connect ecosystem. By joining, you agree to the following policies governing expression, conduct, and platform participation.</p>
  </div>
</div>

<!-- TERMS BODY -->
<div class="terms-body">
  <div class="terms-wrap">

    <span class="tc-meta" data-aos="fade-up" data-aos-duration="700">Last Updated &middot; UMYO Police Connect Platform Policies</span>

    <!-- 01 -->
    <div class="tc-card" data-aos="fade-up" data-aos-duration="800" data-aos-delay="0">
      <div class="tc-num">01</div>
      <h2 class="tc-title">Expression and Ecosystem Scope</h2>
      <p>The Platform operates as a collection of <strong>mission-specific digital ecosystems</strong>. Each ecosystem functions as a purpose-driven private online association with a defined scope of discussion.</p>
      <p>Members are encouraged to engage in open expression within the stated mission and intended purpose of the ecosystem they have joined. Expression is permitted to the extent it aligns with the ecosystem&rsquo;s defined focus and participation standards.</p>
      <p>Content, discussions, or activities that fall outside the stated mission or scope of a particular ecosystem may be moderated, restricted, redirected, or removed at the Company&rsquo;s discretion.</p>
      <p>The Company does not regulate expression based on viewpoint alone. Moderation decisions are based on alignment with ecosystem purpose, adherence to participation standards, and compliance with Platform-wide policies.</p>
      <p>Participation in any ecosystem is conditional and subject to continued compliance with applicable guidelines. Access to an ecosystem is a <strong>revocable license</strong> and may be suspended or terminated for violations of its stated mission, conduct standards, or Platform policies.</p>
      <p>Membership in one ecosystem does not grant rights, privileges, or expression authority within any other ecosystem.</p>
      <div class="tc-highlight">UMYO operates multiple mission-specific private digital ecosystems. Participation is voluntary and conditioned upon agreement to the mission and standards of each ecosystem. The platform does not guarantee unrestricted expression.</div>
      <ul class="tc-list">
        <li>Content may be moderated or removed if deemed outside the mission scope of the selected ecosystem, regardless of viewpoint.</li>
        <li>Mission-aligned expression: Speech is free within the mission of the ecosystem &mdash; not free across all topics everywhere.</li>
      </ul>
    </div>

    <!-- 02 -->
    <div class="tc-card" data-aos="fade-up" data-aos-duration="800" data-aos-delay="80">
      <div class="tc-num">02</div>
      <h2 class="tc-title">Non-Discrimination and Mission Alignment</h2>
      <p>The Company provides access to the Platform <strong>without discrimination</strong> based on race, color, religion, sex, gender identity, sexual orientation, national origin, disability, political affiliation, or other legally protected characteristics.</p>
      <p>Access to individual ecosystems is conditioned upon agreement to and compliance with that ecosystem&rsquo;s stated mission, scope, and participation standards. Moderation decisions are based on:</p>
      <ul class="tc-list">
        <li>Conduct and behavior within the ecosystem</li>
        <li>Mission alignment with the stated ecosystem purpose</li>
        <li>Adherence to Platform-wide policies</li>
        <li>Not on a member&rsquo;s personal identity or protected characteristics</li>
      </ul>
      <p>The Company reserves the right to suspend or terminate participation in any ecosystem where a member&rsquo;s conduct is inconsistent with its stated purpose or applicable guidelines.</p>
    </div>

    <!-- 03 -->
    <div class="tc-card" data-aos="fade-up" data-aos-duration="800" data-aos-delay="80">
      <div class="tc-num">03</div>
      <h2 class="tc-title">Member Appeals and Review Process</h2>
      <p>Members who believe a moderation action was taken in error may submit a written appeal within <strong>fourteen (14) days</strong> of the action.</p>
      <p>Appeals must include sufficient detail to allow review of the decision, including:</p>
      <ul class="tc-list">
        <li>The relevant ecosystem name</li>
        <li>Date of the moderation action</li>
        <li>A description of the basis for the appeal</li>
      </ul>
      <p>Upon receipt of a valid appeal request, the Company will conduct an internal review of the moderation decision. Review may include evaluation of the original content, applicable ecosystem guidelines, and compliance with Platform policies.</p>
      <div class="tc-highlight">The Company may uphold, modify, or reverse the original decision at its discretion. Decisions issued upon appeal are final.</div>
      <p>Submission of an appeal does not guarantee reinstatement, refund, or restoration of access. During the review period, access may remain suspended.</p>
      <p>The Company reserves the right to decline repetitive, abusive, or bad-faith appeals.</p>
    </div>

    <!-- 04 -->
    <div class="tc-card" data-aos="fade-up" data-aos-duration="800" data-aos-delay="80">
      <div class="tc-num">04</div>
      <h2 class="tc-title">Law Enforcement Platform Standards</h2>
      <p>UMYO Police Connect is an <strong>exclusive, verified platform</strong> for law enforcement professionals. All members must maintain conduct consistent with the professional standards of law enforcement.</p>
      <p>The following conduct is strictly prohibited:</p>
      <ul class="tc-list">
        <li>Sharing unverified or false information about law enforcement incidents, policies, or personnel</li>
        <li>Harassment, intimidation, or threatening conduct toward any member</li>
        <li>Unauthorized disclosure of confidential law enforcement information</li>
        <li>Use of the platform to organize unlawful activities</li>
        <li>Impersonating verified law enforcement officers or officials</li>
        <li>Conduct inconsistent with professional law enforcement ethics and standards</li>
      </ul>
      <div class="tc-highlight">Violations may result in immediate suspension, permanent removal, and where applicable, reporting to relevant law enforcement authorities.</div>
    </div>

    <!-- 05 -->
    <div class="tc-card" data-aos="fade-up" data-aos-duration="800" data-aos-delay="80">
      <div class="tc-num">05</div>
      <h2 class="tc-title">Membership &amp; Financial Terms</h2>
      <p>All membership fees are collected on a recurring monthly basis unless otherwise stated. Memberships are <strong>non-refundable</strong> once the billing period has commenced.</p>
      <p>Officer and family relief allocations are <strong>eligibility-based</strong> and subject to program availability. Participation does not constitute a guaranteed financial benefit, investment, or entitlement to any specific allocation.</p>
      <ul class="tc-list">
        <li>Officers &amp; The Blue: $9.99/month &mdash; full platform access and relief fund eligibility</li>
        <li>Supporters &amp; Families: $2.54/month &mdash; community access and family support programs</li>
        <li>Businesses Supporting The Blue: $49.99 nationwide registration</li>
        <li>All allocations are documented, compliance-driven, and eligibility-based</li>
        <li>No gaming, raffle, lottery, or sweepstakes activities are conducted</li>
      </ul>
      <div class="tc-highlight">UMYO Police Connect is a membership-based digital platform. Participation does not constitute investment ownership. All relief programs are eligibility-based. Transparency is foundational to our design.</div>
    </div>

    <!-- 06 -->
    <div class="tc-card" data-aos="fade-up" data-aos-duration="800" data-aos-delay="80">
      <div class="tc-num">06</div>
      <h2 class="tc-title">Compliance &amp; Transparency</h2>
      <p>UMYO Police Connect is committed to full transparency in all financial allocations, program distributions, and operational decisions.</p>
      <ul class="tc-list">
        <li>30% &rarr; Officer &amp; Family Relief Fund (rent, mortgage, car note, grocery, gas, utility)</li>
        <li>20% &rarr; Community Support Programs (family services, youth events, line of duty support)</li>
        <li>50% &rarr; Technology Infrastructure &amp; Platform Development</li>
      </ul>
      <p>All financial activities are subject to internal compliance review. Members may request a summary of allocation activities by submitting a written request to the platform administrator.</p>
      <div class="tc-highlight">No officer left unrecognized. No business left disconnected. A safer, stronger law enforcement community starts here.</div>
    </div>

  </div>
</div>
<!-- FOOTER -->
<footer class="site-footer">
  <div class="footer-inner">
    <div>
      <div class="footer-logo">
        <img src="assets/img/logo.png" alt="Police Officers Connect">
      </div>
      <div class="footer-brand">Police Officers Connect</div>
      <div class="footer-sub-txt">UMYO Network</div>
      <a class="footer-url" rputerLink="/">🌐 www.umyopd.site</a>
    </div>
    <div>
      <div class="footer-col-title">Navigation</div>
      <ul class="footer-links ps-0">
        <li><a routerLink="/">Home</a></li>
        <li><a routerLink="/about">About the Platform</a></li>
        <li><a routerLink="/support">Officer &amp; Family Support</a></li>
        <li><a routerLink="/business">For Businesses</a></li>
        <li><a routerLink="/services">Servcies</a></li>
        <li><a routerLink="/cf">Card Features</a></li>
        <li><a routerLink="/terms">Terms & Condition</a></li>
      </ul>
    </div>
    <div>
      <div class="footer-col-title">Contact</div>
      <div class="footer-contact">
        <div><strong style="color:var(--white);">UMYO Police Connect</strong></div>
        <div>UMYO Network</div>
        <div>3225 Martin Luther King Blvd</div>
        <div>Dallas, Texas 75210</div>
        <div><a routerLink="/">www.umyopd.site</a></div>
      </div>
    </div>
  </div>
</footer>
<div class="footer-bottom">&#169; 2025 UMYO Police Connect &middot; Built for Officers &middot; Powered by Community &middot; Network. Support. Grow. Recognize.</div>